import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const initialTheme = localStorage.getItem("eo_theme") || "dark";
document.documentElement.classList.remove("dark", "light");
document.documentElement.classList.add(initialTheme);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
